import {
    EMPLOYEE_PROFILES_PAGE_ROUTE,
    EMPLOYEE_PROFILES_PAGE_ROUTE_URL,
    SI_ROOT_ROUTE,
} from "app/pages/sales-intelligence/constants/routes";
import { EmployeeProfilesPageContainer } from "app/pages/sales-intelligence/pages/employee-profiles/containers/EmployeeProfilesPageContainer/EmployeeProfilesPageContainer";
import type { SecondaryBarType } from "app/reducers/_reducers/SecondaryBarReducer";
import { fallback } from "app/routes/handlers/redirectFunctions/fallback";
import { redirectPipe } from "app/routes/handlers/redirectFunctions/redirectPipe";
import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

export const employeeProfilesConfig: RouterStateConfig = {
    [EMPLOYEE_PROFILES_PAGE_ROUTE]: {
        parent: SI_ROOT_ROUTE,
        url: EMPLOYEE_PROFILES_PAGE_ROUTE_URL,
        configId: "SalesWorkspace",
        stateId: EMPLOYEE_PROFILES_PAGE_ROUTE,
        component: EmployeeProfilesPageContainer,
        pageTitle: "si.pages.employee_profiles.document_title",
        trackingId: {
            section: "SI_admin",
            subSection: "employee profiles",
            subSubSection: "employee profiles management",
        },
        isSecondaryBarOpen: false,
        secondaryBarType: "None" as SecondaryBarType,
        redirectTo: redirectPipe(
            fallback({
                salesIntelligence: "salesIntelligence-home",
            }),
        ),
    },
};
